export default function fontAwesomeToImg({ path, color }) {
  const svgTemplate = `<svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="${color}" d="${path}"></path></svg>`;

  return `data:image/svg+xml;base64,${btoa(svgTemplate)}`;
}
